<template>
  <div
    v-if="!currentMobile"
    class="picture-background"
    :style="{ opacity: Configuration?.propertyData?.backgroundOpicity?.value }"
    @click="handleClick"
  >
    <img v-if="picturePath !== ''" :src="picturePath" alt="" />
  </div>
  <!-- height: picturHeight + 'px', 
  {
      opacity: Configuration?.propertyData?.backgroundOpicity?.value,
      
    }
  -->
  <div
    v-if="currentMobile"
    class="picture-background-mobile"
    :style="pictureBackgroundSize()"
    @click="handleClick"
  >
    <img v-if="picturePath !== ''" :src="picturePath" alt="" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'PictureBackground',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        this.handeSetImage();
      },
    },
  },
  data() {
    return {
      picturePath: '',
      currentMobile: false,
      picturHeight: '',
      picturWidth: '',
    };
  },
  created() {
    this.handeSetImage();
    this.currentMobile = this.$store.state.isMobile;
    console.log(this.currentMobile, 'currentMobile');
    this.picturHeight = this.ProjectInfo.ScreenSize.height;
    this.picturWidth = this.ProjectInfo.ScreenSize.width;
  },
  methods: {
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    handeSetImage() {
      if (this.Configuration?.propertyData?.backgroundImage?.value) {
        this.picturePath = this.Configuration?.propertyData?.backgroundImage?.value;
      }
    },
    pictureBackgroundSize() {
      return {
        opacity: this.Configuration?.propertyData?.backgroundOpicity?.value,
        height: this.picturHeight + 'px',
      };
    },
  },
  // computed: {
  //   ...mapState({
  //     isMobile: state => state.isMobile,
  //   }),
  // },
  computed: {},
  Configuration: {
    componentTitle: '图片背景',
    componentName: 'PictureBackground',
    componentOverViewImg: './img/backgrounds/PictureBackground.png',
    id: 'PictureBackground',
    style: {
      backgroundColor: 'green',
    },
    propertyData: {
      backgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        configurationAccessKey: 'style',
        value: '#19242D',
        lable: '背景颜色',
      },
      backgroundOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      backgroundImage: {
        propertyComponentName: 'PicturesUploader',
        value: '',
        lable: '图片路径',
      },

      backgroundVideo: {
        // propertyComponentName: 'VideosUploader',
        value: '#',
        lable: '视频路径',
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.picture-background {
  overflow: hidden;
  width: 100%;
  height: 100%;
  color: white;
  img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-attachment: fixed;
  }
}
.picture-background-mobile {
  overflow: hidden;
  width: 100%;
  color: white;
  img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-attachment: fixed;
  }
}
</style>
